export default __webpack_public_path__ + "static/media/35.0ced29c3.jpg";